// extracted by mini-css-extract-plugin
export const mainContainer = "Styles-module--mainContainer--3Mshb";
export const captionContainer = "Styles-module--captionContainer--2QEhN";
export const imageSlide = "Styles-module--imageSlide--Iw99I";
export const title = "Styles-module--title--3jJiZ";
export const subtitle = "Styles-module--subtitle--3NBFa";